import React, {useState} from 'react';
import {CalendarIcon} from "@radix-ui/react-icons"
import {Calendar} from "../../shadCn/components/ui/calendar"
import {Popover, PopoverContent, PopoverTrigger,} from "../../shadCn/components/ui/popover"
import {Button} from "../../shadCn/components/ui/button";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue,} from "../../shadCn/components/ui/select";
import {addDays, format} from "date-fns";
import {cn} from "../../shadCn/lib/utils";
import {toKSTISOString, toKSTISOStringEnd} from "../../components/commonmethod/CommonMethod";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";

function DataPickerWithSelector({target, search, date, setDate, limit, start, listener, id}) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const localeDate = limit ? new Date(limit) : "";

    const handleDateSelect = async (newDate) =>{
        if(start){
            if (!limit || newDate <= localeDate) {
                setDate((prev) => ({
                    ...prev,
                    from: newDate,
                }));
                search.fnc((prevSearchObject) => ({
                    ...prevSearchObject,
                    [target]:toKSTISOString(newDate),
                }));

                if(listener){
                    const response = await listener({id: id, fieldName : target, value : toKSTISOString(newDate)});
                    if(response.status === 200){
                        setIsPopoverOpen(false);
                        handleActiveToast({message: "데이터가 수정되었습니다"});
                    }else if(response.status === 403){
                        handleActiveError({message: "권한이 없습니다."});
                    }else{
                        handleActiveError({message: "알 수 없는 에러 발생."});
                    }
                }
            }else{
                alert("시작일은 종료일 보다 클 수 없습니다.")
            }
        }else if(!start){
            if (!limit || newDate >= localeDate) {
                setDate((prev) => ({
                    ...prev,
                    to: newDate,
                }));
                // 검색시에는 23:59:59로
                search.fnc((prevSearchObject) => ({
                    ...prevSearchObject,
                    [target]:toKSTISOStringEnd(newDate),
                }));
                
                if(listener){
                    const response = await listener({id: id, fieldName : target, value : toKSTISOString(newDate)});
                    if(response.status === 200){
                        setIsPopoverOpen(false);
                        handleActiveToast({message: "데이터가 수정되었습니다"});
                    }else if(response.status === 403){
                        handleActiveError({message: "권한이 없습니다."});
                    }else{
                        handleActiveError({message: "알 수 없는 에러 발생."});
                    }
                }
            }else{
                alert("종료일은 시작일 보다 작을 수 없습니다.")
            }
        }
    }

    const addDayListener = async (value) => {
        if(value) {
            let selectedDate = new Date();
            if(value!== 0){
                selectedDate =addDays(new Date(), parseInt(value))
            }

            if (start) {
                setDate((prev) => ({
                    ...prev,
                    from: selectedDate,
                }));
                search.fnc((prevSearchObject) => ({
                    ...prevSearchObject,
                    [target]: toKSTISOString(selectedDate),
                }));
                
                if(listener){
                    await listener({id: id, fieldName : target, value : toKSTISOString(selectedDate)});
                    setIsPopoverOpen(false);
                }
            } else if (!start) {
                setDate((prev) => ({
                    ...prev,
                    to: selectedDate,
                }));
                // 검색시에는 23:59:59로
                search.fnc((prevSearchObject) => ({
                    ...prevSearchObject,
                    [target]: toKSTISOStringEnd(selectedDate),
                }));

                if(listener){
                    await listener({id: id, fieldName : target, value : toKSTISOString(selectedDate)});
                    setIsPopoverOpen(false);
                }
            }
        }
    };
    return (
        <Popover open={isPopoverOpen} onOpenChange={() => setIsPopoverOpen(!isPopoverOpen)}>
            <PopoverTrigger asChild onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                <Button
                    variant={"outline"}
                    className={cn(
                        "w-[180px] h-[30px] justify-start text-left font-normal",
                        !date && "text-muted-foreground"
                    )}
                >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {date ?  format(date, "L 월 d 일  y 년", ) : <span>Pick a date</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent
                align="start"
                className="flex w-auto flex-col space-y-2 p-2"
            >
                <Select
                    onValueChange={(value) =>
                        addDayListener(value)
                    }
                >
                    <SelectTrigger>
                        <SelectValue placeholder="Select" />
                    </SelectTrigger>
                    <SelectContent position="popper">
                        {start ? (
                            <>
                                <SelectItem value="0">Today</SelectItem>
                                <SelectItem value="-1">Yesterday</SelectItem>
                                <SelectItem value="-3">3 days ago</SelectItem>
                                <SelectItem value="-7">a week ago</SelectItem>
                            </>
                            ):(
                            <>
                                <SelectItem value="0">Today</SelectItem>
                                <SelectItem value="1">Tomorrow</SelectItem>
                                <SelectItem value="3">In 3 days</SelectItem>
                                <SelectItem value="7">In a week</SelectItem>
                            </>
                            )
                        }
                    </SelectContent>
                </Select>
                <div className="rounded-md border">
                    <Calendar mode="single" selected={date} onSelect={handleDateSelect} />
                </div>
            </PopoverContent>
        </Popover>
    );
}

export default DataPickerWithSelector;
